import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import Iconify from '../../ui-component/iconify';
import TableStyle from '../../ui-component/TableStyle';
import { useState } from 'react';
import { Stack, Button, Container, Typography, Box, Card, Popover } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import * as React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MenuItem from '@mui/material/MenuItem';
import { useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import { getApi } from 'views/services/api';
import DeleteCustomer from './DeleteCustomer';
import AddCustomer from './AddCustomer.js';
import EditCustomer from './EditCustomer';

// ----------------------------------------------------------------------

const Customer = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [customerData, setcustomerData] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const navigate = useNavigate();

  const [rowData, setRowData] = useState();

  //function for the dropdowns

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setRowData(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  // function for fetching all the customers data from the db

  const fetchcustomerData = async () => {
    try {
      // const response = await getApi(`api/customer/viewallcustomer/${hotel?._id}`);
      const response = await getApi(`api/customer/viewallcustomer/${hotel?.hotelId}`);
      console.log("response ==>",response);
      
      setcustomerData(response?.data?.customerData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchcustomerData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAdd, openEdit, openDelete]);

  //functions for dialog boxes----------------------------------
  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);

  // edit customer dialog
  const handleOpenEditCustomer = () => {
    setOpenEdit(true);
  };
  const handleCloseEditCustomer = () => {
    setOpenEdit(false);
    handleClose();
  };

  // delete customer dialog
  const handleOpenDeleteCustomer = () => {
    setOpenDelete(true);
  };
  const handleCloseDeleteCustomer = () => {
    setOpenDelete(false);
    handleClose();
  };

  // open view customers
  const handleOpenview = () => {
    navigate(`/dashboard/customer/view/${rowData?.phoneNumber}`);
  };

  //---------------------------------------------------------------------
  const columns = [
    {
      field: `fullName`,
      headerName: 'Name',
      flex: 1,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        return (
          <Box>
            <Box onClick={() => navigate(`/dashboard/customer/view/${params.row.phoneNumber}`)}>{params.value}</Box>
            <div style={{ marginTop: '4px', fontSize: '12px', color: '#777' }}>{params.row.phoneNumber}</div>
          </Box>
        );
      }
    },

    {
      field: 'phoneNumber',
      headerName: 'Phone Number ',
      flex: 1
    },
    {
      field: 'address',
      headerName: 'Address',
      flex: 1
    },
    {
      field: 'idCardType',
      headerName: 'Id Card Type',
      flex: 1
    },
    {
      field: 'idcardNumber',
      headerName: 'Id Card Number',
      flex: 1
    },

    {
      field: 'action',
      headerName: 'Action',
      flex: 1,

      renderCell: (params) => {
        return (
          <>
            <div>
              <IconButton aria-describedby={params?.row._id} variant="contained" onClick={(event) => handleClick(event, params?.row)}>
                <MoreVertIcon />
              </IconButton>
              <Popover
                id={params?.row._id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
              >
                <MenuItem onClick={() => handleOpenEditCustomer()} disableRipple>
                  <EditIcon style={{ marginRight: '8px' }} />
                  Edit
                </MenuItem>
                <MenuItem onClick={() => handleOpenview(params.row._id)} disableRipple>
                  <VisibilityIcon style={{ marginRight: '8px', color: 'green' }} />
                  View
                </MenuItem>
                <MenuItem onClick={() => handleOpenDeleteCustomer()} sx={{ color: 'red' }} disableRipple>
                  <DeleteIcon style={{ marginRight: '8px', color: 'red' }} />
                  Delete
                </MenuItem>
              </Popover>
            </div>
          </>
        );
      }
    }
  ];

  return (
    <>
      <AddCustomer open={openAdd} handleClose={handleCloseAdd} />
      <DeleteCustomer open={openDelete} handleClose={handleCloseDeleteCustomer} id={rowData?.phoneNumber} />
      <EditCustomer open={openEdit} handleClose={handleCloseEditCustomer} data={rowData} />
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Typography variant="h4">Customer-Managment</Typography>
          <Stack direction="row" alignItems="center" justifyContent={'flex-end'} spacing={2}>
            <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenAdd}>
              New Customer
            </Button>
          </Stack>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                Customers ( {customerData?.length || 0} )
              </Typography>
              {customerData && (
                <DataGrid
                  rows={customerData}
                  columns={columns}
                  checkboxSelection
                  getRowId={(row) => row?._id}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{ toolbar: { showQuickFilter: true } }}
                />
              )}
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default Customer;
